import { Component, forwardRef, OnDestroy, OnInit, Input, OnChanges, SimpleChanges, EventEmitter, Output } from '@angular/core';
import * as _ from 'lodash';
import { NG_VALUE_ACCESSOR, FormControl, ControlValueAccessor } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'attensa-editor',
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => AttensaEditorComponent), multi: true }],
    template: `
        <editor [formControl]="editorControl" [init]="editorOptions" (onBlur)="blurred()" (onInit)="editorInit($event)"></editor>
    `
})
export class AttensaEditorComponent implements OnInit, OnChanges, OnDestroy, ControlValueAccessor {
    cleanupTime = new Subject<void>();
    @Input() options: any;
    @Output() editorPlainTextChanged = new EventEmitter<any>();
    editorOptions: any;
    editorControl = new FormControl();
    onChangeCallback: any = () => { };
    onTouchedCallback: any = () => { };
    editor: any;

    constructor() {}

    ngOnInit(): void {
        this.editorControl.valueChanges.pipe(takeUntil(this.cleanupTime)).subscribe(val => {
            this.editorPlainTextChanged.emit(this.editor.getContent({ format: 'text' }));
            this.onChangeCallback(val);
        });
        this.editorOptions = this.buildEditorOptions(this.options);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.options && changes.options.currentValue) {
            this.editorOptions = this.buildEditorOptions(this.options);
        }
    }

    editorInit({ editor }) {
        this.editor = editor;
    }

    writeValue(obj: any): void {
        this.editorControl.setValue(obj, { emitEvent: false });
    }

    registerOnChange(fn: any): void {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouchedCallback = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        isDisabled ? this.editorControl.disable() : this.editorControl.enable();
    }

    buildEditorOptions(overrides = {}) {
        return _.defaults({}, overrides, {
            plugins: 'autoresize advlist autolink lists charmap preview anchor ' +
                     'searchreplace visualblocks code fullscreen insertdatetime media table paste link image',
            toolbar: 'restoredraft | insertfile undo redo | styleselect | forecolor backcolor | bold italic | alignleft aligncenter alignright alignjustify ' +
                     '| bullist numlist outdent indent link code',
            autoresize_bottom_margin: 1,
            inline: false,
            height: 100,
            width: '100%',
            branding: false,
            browser_spellcheck: true,
        });
    }

    blurred(): void {
        this.onTouchedCallback();
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}